<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const isFullWidthRoute = computed(
  () => route.name === 'report_dashboard_index'
);
</script>

<template>
  <div
    class="bg-n-surface-1 w-full h-full"
    :class="
      isFullWidthRoute ? 'overflow-hidden flex flex-col' : 'overflow-auto px-6'
    "
  >
    <div
      :class="
        isFullWidthRoute
          ? 'w-full h-full flex flex-col'
          : 'max-w-5xl mx-auto pb-12'
      "
    >
      <router-view />
    </div>
  </div>
</template>
